// BARRA DE COMPRA FIJA EN MOVIL (08-10-2026, Jaime: «arregla todas las mejoras»).
// Cuando el boton «Add to cart» de la ficha se queda por encima de la pantalla (bajando por las
// fotos o por DETAILS), aparece abajo una barra con titulo, precio y el mismo boton. No es un
// formulario aparte: pulsa el boton de verdad, asi respeta la talla elegida y todo lo que hace el
// tema al anadir. Solo en movil, solo en fichas y solo si el boton esta activo (en una agotada no
// sale). Se recalcula al hacer scroll (un getBoundingClientRect por fotograma como mucho), porque
// Dawn sustituye el boton al cambiar de talla y un IntersectionObserver se quedaria con el viejo.
(function () {
  var SELECTOR = '.product-form__submit[name="add"]';
  if (!document.querySelector(SELECTOR)) return;
  var mq = window.matchMedia('(max-width: 749px)');

  var bar = document.createElement('div');
  bar.className = 'cs-sticky-atc';
  bar.setAttribute('aria-hidden', 'true');
  bar.innerHTML =
    '<div class="cs-sticky-atc__text">' +
    '<span class="cs-sticky-atc__title"></span>' +
    '<span class="cs-sticky-atc__price"></span>' +
    '</div>' +
    '<button type="button" class="button button--primary cs-sticky-atc__btn" tabindex="-1"></button>';
  document.body.appendChild(bar);

  var titleEl = bar.querySelector('.cs-sticky-atc__title');
  var priceEl = bar.querySelector('.cs-sticky-atc__price');
  var btnEl = bar.querySelector('.cs-sticky-atc__btn');
  var visible = false;

  function sync() {
    var h1 = document.querySelector('.product__title h1') || document.querySelector('h1');
    titleEl.textContent = h1 ? h1.textContent.trim() : '';
    var price = document.querySelector('.product__info-container .price .price-item--regular');
    priceEl.textContent = price ? price.textContent.replace(/\s+/g, ' ').trim() : '';
    var live = document.querySelector(SELECTOR);
    btnEl.textContent = live ? live.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function show(on) {
    if (on === visible) return;
    visible = on;
    if (on) sync();
    bar.classList.toggle('is-visible', on);
    bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    btnEl.tabIndex = on ? 0 : -1;
    document.body.classList.toggle('cs-sticky-atc-on', on);
  }

  function check() {
    var live = document.querySelector(SELECTOR);
    if (!live || !mq.matches || live.disabled || live.getAttribute('aria-disabled') === 'true') {
      show(false);
      return;
    }
    show(live.getBoundingClientRect().bottom < 0);
  }

  var ticking = false;
  window.addEventListener(
    'scroll',
    function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        check();
      });
    },
    { passive: true }
  );
  mq.addEventListener('change', check);
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('variant-selects')) setTimeout(function () { sync(); check(); }, 400);
  });

  btnEl.addEventListener('click', function () {
    var live = document.querySelector(SELECTOR);
    if (live && !live.disabled) live.click();
  });

  check();
})();
